import i31 from '../../img/sandwich/31.jpg'
import i32 from '../../img/sandwich/32.jpg'
import i33 from '../../img/sandwich/33.jpg'
import i34 from '../../img/sandwich/34.jpg'
import i35 from '../../img/sandwich/35.jpg'
import i36 from '../../img/sandwich/36.jpg'

export const sandwich=[
    {
        "id" : 31 ,
        "title" : "ساندویچ هات داگ کلاسیک",
        "price":"130",
        "desciption":"یک عدد هات داگ سرخ شده ، سس مخصوص ، کاهو ، گوجه ، خیارشور و نان فرانسوی کنجدی  ",
        "image" : i31
    },
    {
        "id" : 32 ,
        "title" : "ساندویچ هات داگ با قارچ و پنیر  ",
        "price":"170",
        "desciption":"یک عدد هات داگ سرخ شده ، سس مخصوص ، کاهو ، گوجه ، خیارشور ، نان فرانسوی کنجدی ، قارچ و پنیر موزارلا  برگر 160گرم ، فیله مرغ گریل شده ، قارچ و پنیر گودا  ",
        "image" : i32
    },
    {
        "id" : 33 ,
        "title" : "ساندویچ ابر هات داگ",
        "price":"210",
        "desciption":"2 عدد هات داگ سرخ شده ، قارچ ، پنیر موزارلا ، کاهو ، گوجه ، خیارشور ، نان فرانسوی کنجدی ",
        "image" : i33
    },
    {
        "id" : 34 ,
        "title" : "ساندویچ ژامبون سرد",
        "price":"160",
        "desciption":"ژامبون گوشت و مرغ ، کاهو ، گوجه ، خیارشور و نان فرانسوی کنجدی  ",
        "image" : i34
    },
    {
        "id" : 35 ,
        "title" : "ساندویچ ژامبون تنوری",
        "price":"210",
        "desciption":"ژامبون گوشت و مرغ تنوری شده ، قارچ ، پنیر موزارلا ، کاهو ، گوجه ، خیارشور و نان فرانسوی کنجدی  ",
        "image" : i35
    },
    {
        "id" : 36 ,
        "title" : "ساندویچ مرغ با قارچ و پنیر",
        "price":"360",
        "desciption":"استیک مرغ ، قارچ ، پنیر موزارلا ، کاهو ، گوجه ، خیارشور و نان فرانسوی کنجدی ",
        "image" : i36
    },
   
]